import React, { useState } from "react";
import "./LiveUpdates.css";


const LiveUpdates = () => {
  
  return (
    <div className='liveupdates-container'>
      <p>// Live Updates coming soon //</p>
    </div>
  );
};

export default LiveUpdates;